import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { EMPTY_FIELD } from 'support/helpers/const/const';
import { routeToPage } from 'support/helpers/navigation/navigation';
import { InvoiceVerificationDTO, TransactionsRoutes } from 'support/types';

export const RelatedTransactionsContent = ({
  relatedTransactions,
}: {
  relatedTransactions: Required<
    Required<InvoiceVerificationDTO>['payload']
  >['matched_line_items'][number]['related_messages'];
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <div className="text-xs text-gray-500">
        {t('invoiceVerification:detailsPage.discrepanciesModal.content.relatedTransactions.title')}
        <ul className="flex flex-col gap-1 pt-3">
          {relatedTransactions?.map((transaction, index) => (
            <li key={index} className="mt-2 flex justify-between gap-2">
              <span className="shrink-0">{t(`common:messageTypes.singular.${transaction.type}`)}:</span>
              <Link
                target="_blank"
                className="text-end text-gray-700 underline hover:text-procuros-green-600"
                to={routeToPage(TransactionsRoutes.viewMessage, { id: transaction.id || null })}
              >
                {transaction.external_message_reference || EMPTY_FIELD}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
